import type { IComponentController } from "angular";
import "angular-translate";
import { maxBy as lodashMaxBy } from "lodash";
import moment from "moment-timezone";

import type { IAlarm, IResponseWithLoading } from "App/Modules/Models";
import { FunctionalityType, FunctionalityTypeFunctions } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class LatestSupervisionsComponentController implements IComponentController {
    public static $inject: string[] = ["$translate", "mmSitesRepository"];

    public caption: string;

    public supervisions: IResponseWithLoading<IAlarm[]>;

    public timeSinceLastAlarm: string;

    public icon: string;

    public siteId: string;

    public subCaption: string;

    constructor(
        private readonly $translate: angular.translate.ITranslateService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        this.caption = "Entities.Site.Supervisions";
        this.icon = FunctionalityTypeFunctions.functionalityTypeIcon(FunctionalityType.Care);

        const dtFrom = moment.utc().subtract(7, "days").format();
        const dtTo = moment.utc().format();

        extendWithLoadingAndFail(this.sitesRepository.getAlarmsHistoryForSite(this.siteId, dtFrom, dtTo)).subscribe(
            (alarmResponse) => {
                this.supervisions = alarmResponse;
                if (this.supervisions.isLoading) {
                    return;
                }

                const lastAlarm = lodashMaxBy(this.supervisions.data, (supervision) => supervision.dtAlarm);

                if (lastAlarm) {
                    this.timeSinceLastAlarm = lastAlarm.dtAlarm.fromNow(true);
                    this.subCaption = this.$translate.instant("Entities.Site.LastSupervision");
                }

                this.caption = this.$translate.instant(
                    "Entities.Site.NumSupervisionsLastWeekFormat",
                    { numSupervisions: this.supervisions.data.length },
                    "messageformat",
                );
            },
        );
    }
}
